import * as tsx from 'vue-tsx-support';
import { Maybe } from '@codegrade/maybe';
import { Card } from '@/components/Card';
import PreferenceManager from '@/components/PreferenceManager';
import SnippetSettings from '@/components/SnippetSettings';
import UserInfo from '@/components/UserInfo';
import UserNotifications from '@/components/UserNotifications';
import UserTransactions from '@/components/UserTransactions';
import { GlobalPermissions as GPerm } from '@/permissions';
import { UserStore } from '@/store';
import * as utils from '@/utils';
export default tsx.componentFactoryOf().create({
    name: 'sidebar-user-info',
    computed: {
        /** @returns Whether we are currently viewing this component in student view. */
        isStudentViewEnabled() {
            return UserStore.studentView().tag === 'enabled';
        },
        /** @returns Whether the logged in user has the *global* permission to use snippets. */
        canUseSnippets() {
            return UserStore.tenantId().mapOrDefault(tid => UserStore.hasTenantPermission()(GPerm.can_use_snippets, tid), false);
        },
        /** @returns The rendered snippet manager if we need to render it for the current user. */
        snippetsNode() {
            return utils.ifOrEmpty(this.canUseSnippets, () => (<SnippetSettings course={Maybe.empty()}/>));
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        transactionsNode() {
            return utils.ifJustOrEmpty(UserStore.loggedInUser(), user => (<UserTransactions user={user}/>));
        },
        /** @returns The preferences node if we need to render it. */
        preferencesNode() {
            return (<Card header="Preferences">
                    <PreferenceManager showLanguage={false} showWhitespace={false} showContextAmount={false} showInlineFeedback={false} showTabPreset={true} showWhitespacePreset={true}/>
                </Card>);
        },
        /** @returns The rendered user info panel for the current user state. */
        bodyNode() {
            return utils.ifExpr(this.isStudentViewEnabled, () => <UserNotifications />, () => [
                this.preferencesNode,
                <UserInfo />,
                <UserNotifications />,
                this.snippetsNode,
                this.transactionsNode,
            ]);
        },
    },
    /** @returns The rendered sidebar user info panel. */
    render() {
        return <div class="sidebar-user-info space-y-4">{this.bodyNode}</div>;
    },
});
